import { useContext, useEffect, useRef, useState } from "react";
//scss
import "./style.scss";

//assets
import { SvgCross } from "assets/icons/js/SvgCross";

import { ReactComponent as MarriottbonvoyIcon } from "assets/marriottbonvoy.svg";

import { SvgMariottListing } from "assets/icons/js/SvgMariottListing";
import { ReactComponent as SafeIcon } from "assets/100%Safe.svg";
import { ReactComponent as PlusIcon } from "assets/plus.svg";
import { ReactComponent as MinusIcon } from "assets/minus.svg";

//components
import Modal from "components/LoginAndRegister/Modal";
import IconText from "../Icon-text";
import { useOnClickOutside } from "customHooks/useOnClickOutside";
import AmenityIcon from "../AmenityIcon";
import axios from "axios";
import { ListingInterface } from "context/ListingData";
import { useTheme } from "components/ListingNew/ListingTheme";

const AllAmenities = ({ amenityList, open, setOpen, notPresent }) => {
	const popupRef = useRef(null);
	useOnClickOutside(popupRef, () => setOpen(false));

	const { newListingId } = useContext(ListingInterface);

	const [petData, setPetData] = useState({});
	const getPetExpand = async () => {
		const res = await axios.get(
			"https://go.saffronstays.com/api/get-pet-expand?listingId=" +
				newListingId,
		);
		if (res.data.success) {
			setPetData(JSON.parse(res.data.data || {}));
		}
	};

	useEffect(() => {
		amenityList.forEach((ele, indx) => {
			if (
				ele.category === "Facilities" &&
				amenityList[indx]?.amenities
					?.map((ele) => Object.keys(ele)[0])
					?.includes("19")
			) {
				getPetExpand();
			}
		});
	}, []);

	const [expandPet, setExpandPet] = useState(false);
	const theme = useTheme();
	return (
		<div className="all-amenities__wrapper">
			<Modal shouldShow={open} onClose={() => setOpen(false)}>
				<div
					className="all-amenities"
					ref={popupRef}
					style={{ background: theme?.background2 }}
				>
					<h3
						style={{
							background: theme?.background2,
							color: theme?.primaryTextColor,
						}}
					>
						Amenities{" "}
						<SvgCross
							id="all-amenities__cross"
							onClick={() => setOpen(false)}
						/>
					</h3>
					<div className="all-amenities__body">
						{amenityList.map((itemMain, index) => {
							if (itemMain.category === "null") {
								return null;
							}
							return (
								<div className="all-amenities__category" key={index}>
									<div
										className="sub-heading"
										style={{ color: theme.primaryTextColor }}
									>
										{itemMain.category}
									</div>
									<div className="amenity-list">
										{itemMain.amenities.map((item, index) => {
											if (Object.values(item)[0] === "Marriott Bonvoy Home") {
												if (theme?.name === "xseries") {
													return <SvgMariottListing />;
												}
												return (
													<MarriottbonvoyIcon
														id="marriot-icon"
														style={{
															alignSelf: "baseline",
														}}
													/>
												);
											}
											if (Object.values(item)[0] === "100% Safe To Travel") {
												return <SafeIcon />;
											}

											if (Object.values(item)[0] === "Pet Friendly") {
												if (
													itemMain.amenities
														?.map((ele) => Object.keys(ele)[0])
														?.includes("14")
												) {
													return null;
												}
												return (
													<div
														className={
															"pet-wrapper " + (expandPet && "expand-pet")
														}
													>
														<div
															className="icon-text__wrapper"
															style={{ color: theme?.baseTextColor }}
														>
															<AmenityIcon id={Object.keys(item)} />
															{Object.values(item)[0]}
															{Object.keys(petData).length !== 0 && (
																<div className="expand-btn">
																	{!expandPet && (
																		<span id="span-text">What we provide</span>
																	)}
																	{expandPet ? (
																		<MinusIcon
																			onClick={() => {
																				setExpandPet(false);
																			}}
																		/>
																	) : (
																		<PlusIcon
																			onClick={() => {
																				setExpandPet(true);
																			}}
																		/>
																	)}
																</div>
															)}{" "}
														</div>
														<div
															className={`pet-expand-wrapper ${
																expandPet && "open-expand"
															}`}
														>
															{petData?.amenities?.map((ele) => {
																return (
																	<div className="icon-text__wrapper">
																		{ele.status === "v" ? (
																			ele.name
																		) : (
																			<s>{ele.name}</s>
																		)}
																	</div>
																);
															})}
														</div>
													</div>
												);
											}
											return <IconText {...item} key={index} />;
										})}
									</div>
								</div>
							);
						})}
						{notPresent &&
							Object?.values(notPresent)?.map((item, index) => {
								return (
									<div className="all-amenities__category" key={index}>
										{index === 0 && (
											<div
												className="sub-heading"
												style={{
													borderTop: "2px solid #dddddd",
												}}
											>
												{""}
											</div>
										)}
										<div className="amenity-list">
											<p>
												{item}
												<hr />
											</p>
											{/* {item.map((item, index) => {
												return <IconText {...item} key={index} />;
											})} */}
										</div>
									</div>
								);
							})}
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default AllAmenities;
